module.exports = __webpack_public_path__ + "static/OpenSans-BoldItalic-9fcc94ac00500a480319826946332e8f.woff2";